import type { ComboBoxOptions } from '@interstate/components/ComboBox';
import type { InterstateOnChangeEvent } from '@interstate/components/InterstateEvents';

export const getValueFromComboboxChangeEvent = (event: InterstateOnChangeEvent<ComboBoxOptions>): string | undefined => {
    return event.target.value[0]?.value;
};
